const NODE_ENV = (process.env.NODE_ENV || 'development').toUpperCase();

const AWS_REGION = process.env[`VUE_APP_AWS_REGION_${NODE_ENV}`];

const COGNITO_USER_POOL = process.env[`VUE_APP_COGNITO_USER_POOL_${NODE_ENV}`];

const COGNITO_USER_POOL_CLIENT = process.env[`VUE_APP_COGNITO_USER_POOL_CLIENT_${NODE_ENV}`];

const COGNITO_USER_POOL_DOMAIN = process.env[`VUE_APP_COGNITO_USER_POOL_DOMAIN_${NODE_ENV}`];

const COGNITO_AUTH_TYPE = process.env[`VUE_APP_COGNITO_AUTHENTICATION_FLOW_TYPE_${NODE_ENV}`];

const COGNITO_REDIRECT_SIGN_IN = process.env[`VUE_APP_COGNITO_REDIRECT_SIGN_IN_${NODE_ENV}`];

const COGNITO_REDIRECT_SIGN_OUT = process.env[`VUE_APP_COGNITO_REDIRECT_SIGN_OUT_${NODE_ENV}`];

const PROXY_API_GW_URL = process.env[`VUE_APP_PROXY_API_GW_URL_${NODE_ENV}`];

const AUTH_API_GW_URL = process.env[`VUE_APP_AUTH_API_GW_URL_${NODE_ENV}`];

const CLIENT_CONFIG_URL = process.env[`VUE_APP_CLIENT_CONFIG_URL_${NODE_ENV}`];

const DEFAULT_COLOR_FOR_LOADER = process.env[`VUE_APP_DEFAULT_COLOR_FOR_LOADER_${NODE_ENV}`];

const HOTJAR_ID = process.env[`VUE_APP_HOTJAR_ID_${NODE_ENV}`];

const HOTJAR_SERVICE_VERSION = process.env[`VUE_APP_HOTJAR_SERVICE_VERSION_${NODE_ENV}`];

const TRUE_TO_STRING = 'true';

const ROUTES_NAMES = {
  login: 'login',
  registration: 'registration',
  confirmSignUp: 'confirmSignUp',
  logout: 'logout',
  forgotPassword: 'forgotPassword',
  forgotPasswordConfirm: 'forgotPasswordConfirm',
  federatedLogin: 'federatedLogin',
  federatedLogout: 'federatedLogout',
  otp: 'otp',
  error: 'error'
};

const SOCIAL_PROVIDERS = {
  GOOGLE: 'google',
  FACEBOOK: 'facebook',
  APPLE: 'apple'
};

export {
  AWS_REGION,
  COGNITO_USER_POOL,
  COGNITO_USER_POOL_CLIENT,
  COGNITO_USER_POOL_DOMAIN,
  COGNITO_AUTH_TYPE,
  PROXY_API_GW_URL,
  AUTH_API_GW_URL,
  CLIENT_CONFIG_URL,
  COGNITO_REDIRECT_SIGN_IN,
  COGNITO_REDIRECT_SIGN_OUT,
  ROUTES_NAMES,
  SOCIAL_PROVIDERS,
  DEFAULT_COLOR_FOR_LOADER,
  TRUE_TO_STRING,
  HOTJAR_ID,
  HOTJAR_SERVICE_VERSION
};
